export const ShortcodeBlockIcon = () => (
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" viewBox="0 0 512 512">
		<defs>
			<style>{ '.st1{fill:#f26c0d}' }</style>
		</defs>
		<path
			d="M46.5 448V64c0-9.7 7.8-17.5 17.5-17.5h69.8v-45H64C29.5 1.5 1.5 29.5 1.5 64v384c0 34.5 28 62.5 62.5 62.5h69.8v-45H64c-9.7 0-17.5-7.9-17.5-17.5ZM448 1.5h-69.8v45H448c9.7 0 17.5 7.8 17.5 17.5v384c0 9.7-7.8 17.5-17.5 17.5h-69.8v45H448c34.5 0 62.5-28 62.5-62.5V64c0-34.5-28-62.5-62.5-62.5Z"
			className="st1"
		/>
		<path
			d="M377.1 221.6h22.4c10.1 0 10.1-16.5 0-16.5h-22.4c-10.8 0-10.8 16.5 0 16.5ZM290.5 134.6c-.7 4.3 3.6 7.9 7.9 7.9 13 0 6.5-23 7.9-30.2 0-4.3-3.6-7.9-7.9-7.9-13 0-6.5 23-7.9 30.2ZM359.8 263.4c-7.2-7.2-18.8 4.3-11.5 11.5l15.9 15.8c7.2 7.2 18.8-4.3 11.5-11.5-.7 0-15.9-15.8-15.9-15.8ZM236.3 163.4c7.2 7.2 18.8-4.3 11.5-11.5l-15.9-15.8c-6.5-7.2-18.8 4.3-10.8 11.5l15.2 15.8ZM359.8 163.4l15.2-15.8c7.2-7.2-4.3-18.7-11.6-11.5l-15.9 15.8c-6.5 7.2 5.1 18.7 12.3 11.5ZM353.3 213c1.4-51.8-70-74.8-99.6-33.1 11.6 8.6 20.2 18 26 30.9 26-2.2 51.3 12.9 61.4 36.7 7.9-10.1 12.3-22.3 12.3-34.5ZM275.3 330.3H123c-13.7 0-13.7 21.6 0 20.9h152.3c22.4-1.4 30.3 35.2 5.1 36.7-8.7 0-15.9-7.2-15.9-15.8 0-13.7-20.9-13.7-20.9 0-.7 47.5 74.4 47.5 73.6 0 0-23.1-18.8-41.7-41.9-41.7Z"
			className="st1"
		/>
		<path
			d="M317.2 239.6c-41.2-36-57 8.6-76.5 2.9-10.1-13 14.4-23.7 23.8-28.1-30.3-54.7-108.3-31.6-117.7 25.2-21.7 1.4-42.6 14.4-41.9 38.8 0 20.9 16.6 37.4 37.5 37.4h143c39 1.4 59.9-49.6 31.8-76.2Zm-175.5 56.1c-22.4 0-22.4-34.5 0-34.5 22.4-.7 22.4 34.5 0 34.5Z"
			className="st1"
		/>
	</svg>
);
